<template>
  <div
    id="addBadge"
    class="tab-pane "
    role="tabpanel"
  >
    <!-- .name -->
    <b-form-group
      id="input-group-1"
      :label="$t('nationality.name')"
      label-for="input-1"
    >
      <b-form-input
        id="input-1"
        v-model="newItem.name"
        type="text"
        :placeholder="$t('nationality.name')"
      />
    </b-form-group>
    <!-- .active -->
    <b-form-group
      id="input-group-2"
      :label="$t('nationality.active')"
      label-for="input-2"
    >
      <b-form-input
        id="input-2"
        v-model="newItem.active"
        type="text"
        :placeholder="$t('nationality.active')"
      />
    </b-form-group>

    <div class="form-group">
      <button
        type="button"
        class="btn btn-primary"
        @click="submit()"
      >
        <i class="fa fa-plus" /> {{ $t('site.save') }}
      </button>
    </div>
  </div>
</template>

<script>
import Controller from '../../../../Controllers/NationalityController'
import config from '../../../../config/config'

const controller = new Controller()
export default {
  name: 'NationalityForm',
  components: {
    Select2,
  },
  props: ['newItem'],
  data() {
    return {
      file: {},
      

    }
  },
  methods: {
       goToTable() {
      this.$parent.$parent.$children[0].$children[0].$refs.table.refresh();
      this.$parent.$parent.firstTab();
    },
    async submit() {
      controller.From(this.newItem, 'FormData')
    },
    // async created() {
    //    const data = await controller.created();
    //    data.
    // },

  },

}
</script>
